<template>
  <div class="endbox">
    <div v-if="!isPc" class="h5Box">
      <div
        class="handleBox flex_center"
        style="position: fixed; margin-top: 10px; right: 5px"
      >
        <help-tip ref="helpTipRef"></help-tip>
        <div class="langBox">
          <change-i18n-component></change-i18n-component>
        </div>
      </div>
      <div class="h5bg">
        <img src="../../assets/login/h5bg.png" alt="" style="width: 100%" />
        <img
          class="leftBoxEn"
          src="~@/assets/images/logo-blue-en.png"
          alt=""
          v-if="$store.state.dict.lang == 'en'"
        />
        <img
          class="leftBoxZh"
          src="~@/assets/images/logo-blue.png"
          alt=""
          v-if="$store.state.dict.lang == 'zh'"
        />
      </div>
    </div>
    <div class="loginpage">
      <div class="loginHeader flex_center_between" v-if="isPc">
        <img
          class="leftBoxEn"
          src="~@/assets/images/logo-blue-en.png"
          alt=""
          v-if="$store.state.dict.lang == 'en'"
        />
        <img
          class="leftBoxZh"
          src="~@/assets/images/logo-blue.png"
          alt=""
          v-if="$store.state.dict.lang == 'zh'"
        />
        <div class="rightBox flex_center_between">
          <help-tip ref="helpTipRef"></help-tip>
          <div class="langBox">
            <change-i18n-component></change-i18n-component>
          </div>
        </div>
      </div>
      <!-- 注册页面框框  -->
      <div class="device-type-cla">
        <div class="out-box-login" v-if="true">
          <div class="title-span">
            <span v-if="$store.state.dict.lang == 'zh'">{{
              meetingSubject
            }}</span>
            <span v-if="$store.state.dict.lang == 'en'">{{
              meetingSubjectEn
            }}</span>
          </div>
          <div class="chose-out">
            <span
              class="chose-in"
              :class="choseActive == 'register' ? 'active' : ''"
              @click="changeFunc('register')"
              >{{ $t("common.signUp") }}</span
            >
            <span
              class="chose-in"
              :class="choseActive == 'login' ? 'active' : ''"
              @click="changeFunc('login')"
              >{{ $t("common.signIn") }}</span
            >
          </div>

          <div v-if="showType == '1'">
            <!--  切换邮箱手机号    -->
            <div class="chose-way-out">
              <span
                :class="activeWay == 'mail' ? 'active' : ''"
                @click="choseWayFunc('mail')"
                >{{ $t("common.email") }}</span
              >
              <div class="shu"></div>
              <span
                :class="activeWay == 'phone' ? 'active' : ''"
                @click="choseWayFunc('phone')"
                >{{ $t("common.phone") }}</span
              >
            </div>
            <!--      邮箱框框-->
            <div v-if="activeWay == 'mail'">
              <el-form
                ref="formMail"
                :model="formMail"
                :rules="rules"
                label-position="left"
                label-width="0px"
                key="formMail"
              >
                <el-form-item prop="mail">
                  <el-input
                    v-model="formMail.mail"
                    :placeholder="this.$t('common.email')"
                    auto-complete="off"
                  >
                    <template slot="prepend">{{ $t("common.email") }}</template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="passcode">
                  <!-- @blur="queryVerifyCodeOfEmail" -->
                  <el-input
                    type="text"
                    v-model="formMail.passcode"
                    auto-complete="new-password"
                    :placeholder="this.$t('common.pleaseInputVerificationCode')"
                    name="passcode"
                  >
                    <el-button
                      v-if="formMail.sendCode"
                      @click.native="sendMessageMail"
                      slot="append"
                      >{{ $t("common.getEmailVerificationCode") }}
                    </el-button>
                    <el-button
                      v-if="!formMail.sendCode"
                      slot="append"
                      style="width: 120px"
                      >{{ formMail.sendTime }}s{{ $t("common.sendAgain") }}
                    </el-button>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="formMail.password"
                    auto-complete="new-password"
                    :placeholder="this.$t('common.password')"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="checkPassMail">
                  <el-input
                    type="password"
                    v-model="formMail.checkPassMail"
                    auto-complete="new-password"
                    :placeholder="this.$t('common.passwordAgain')"
                  ></el-input>
                </el-form-item>
                <div class="me-button" @click="registerMail">
                  {{ $t("common.signUp") }}
                </div>
                <user-protect-component
                  v-model="isCheck"
                ></user-protect-component>
              </el-form>
              <el-row></el-row>
            </div>
            <!--   手机号框框    -->
            <div v-if="activeWay == 'phone'">
              <el-form
                ref="formMobile"
                :model="formPhone"
                :rules="rules"
                label-position="left"
                label-width="0px"
                key="formPhone"
              >
                <el-form-item prop="mobile">
                  <el-input
                    v-model="formPhone.mobile"
                    :placeholder="this.$t('common.pleaseInputPhone')"
                    auto-complete="off"
                  >
                    <template slot="prepend">+86</template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="passcode">
                  <el-input
                    type="text"
                    v-model="formPhone.passcode"
                    auto-complete="new-password"
                    :placeholder="this.$t('common.pleaseInputVerificationCode')"
                    name="formPhone.passcode"
                  >
                    <el-button
                      v-if="formPhone.sendCode"
                      @click.native="sendMessageMobile"
                      slot="append"
                      >{{ $t("common.getPhoneVerificationCode") }}
                    </el-button>
                    <el-button
                      v-if="!formPhone.sendCode"
                      slot="append"
                      style="width: 120px"
                      >{{ formPhone.sendTime }}s{{ $t("common.sendAgain") }}
                    </el-button>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="formPhone.password"
                    auto-complete="new-password"
                    :placeholder="this.$t('common.password')"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="checkPassMobile">
                  <el-input
                    type="password"
                    v-model="formPhone.checkPassMobile"
                    auto-complete="new-password"
                    :placeholder="this.$t('common.passwordAgain')"
                  ></el-input>
                </el-form-item>
                <div class="me-button" @click="registerMobile">
                  {{ $t("common.signUp") }}
                </div>
              </el-form>
              <user-protect-component
                v-model="isCheck"
              ></user-protect-component>
            </div>
          </div>

          <!--        成功框框-->
          <div class="sucess-out" v-if="showType == '3'">
            <div class="sucess-img-out">
              <div class="sucess-img"></div>
              <span> {{ $t("msg.singSuccess") }}</span>
            </div>
            <div class="me-button" @click="changeFunc('login')">
              {{ $t("common.gologin") }}
            </div>
          </div>

          <!--        邮箱激活提示框框-->
          <div class="mail-tip-out" v-if="showType == '2'">
            <div class="mail-img-out">
              <div class="sucess-img"></div>
            </div>
            <span>提示: 请您去邮箱进激活确认, 击邮件中的链接即可完成注册</span>
            <span>如果您未能接受到邮件，建议您：</span>
            <span>1）查看被拦截邮件或垃圾邮箱</span>
            <span>2）更换其他电子邮箱尝试</span>
            <span>3）联系我们（contact@51xueshuo.com）</span>
            <span class="blueSpan"
              ><i class="el-icon-s-promotion"></i>点击再次发送邮件</span
            >
            <div class="mail-btn-out">
              <div class="bakck" @click="showType = '1'">返回修改邮箱</div>
              <div class="over" @click="changeFunc('login')">我已完成激活</div>
            </div>
          </div>

          <div class="little-btn-divv2">
            <invite-component
              :userName="''"
              :meetingTitle="''"
              :pageType="'login'"
            ></invite-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpTip from "@/components/tip/helpTip";
import changeI18nComponent from "@/components/common/changeI18nComponent";
import inviteComponent from "@/components/common/inviteComponent";
import MailTipComponent from "@/components/login/mailTipComponent";
import userProtectComponent from "../../components/login/userProtectComponent";
import utils from "@/utils/utils";
export default {
  components: {
    changeI18nComponent,
    inviteComponent,
    userProtectComponent,
    helpTip,
  },
  data() {
    return {
      visibled: false,
      canGoIndex: false,
      meetingCode: "",
      formMail: {
        mail: "",
        password: "",
        checkPassMail: "",
        passcode: "", //验证码
        sendCode: true,
        sendTime: 0,
      },
      formPhone: {
        mobile: "",
        password: "",
        checkPassMobile: "",
        passcode: "",
        sendCode: true,
        sendTime: 0,
      },
      //页面使用的
      choseActive: "register", //login register
      activeWay: "phone",
      showType: 1, //1注册input框 2：成功框框  3：邮箱激活提示框
      meetingSubject: "会议管理系统",
      meetingSubjectEn: "Meeting Manage System",
      isCheck: false,
    };
  },
  computed: {
    rules() {
      var validatePassMail = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("common.passwordAgain")));
        } else if (value !== this.formMail.password) {
          callback(new Error(this.$t("common.passIsNotSame")));
        } else {
          callback();
        }
      };
      var validatePassMobile = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("common.passwordAgain")));
        } else if (value !== this.formPhone.password) {
          callback(new Error(this.$t("common.passIsNotSame")));
        } else {
          callback();
        }
      };

      const rules = {
        mail: [
          {
            required: true,
            message: this.transZhEnDynamic("NotNull"),
            trigger: "blur",
          },
          // {
          //   pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
          //   message: "请输入正确的账号",
          //   trigger: "blur",
          // },
        ],
        mobile: [
          {
            required: true,
            message: this.transZhEnDynamic("NotNull"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.transZhEnDynamic("pleaseInputRightPhone"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.transZhEnDynamic("NotNull"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 18,
            pattern: /^[A-Za-z0-9]{6,18}$/,
            message: this.transZhEnDynamic("pleaseInputPass"),
            trigger: "blur",
          },
        ],
        passcode: [
          {
            required: true,
            message: this.transZhEnDynamic("pleaseInputVerificationCode"),
            trigger: "blur",
          },
        ],
        checkPassMail: [
          { validator: validatePassMail, trigger: "blur", required: true },
        ],
        checkPassMobile: [
          { validator: validatePassMobile, trigger: "blur", required: true },
        ],
      };
      return rules;
    },
  },
  created() {
    this.isPc = utils.isPc();
    let meetingCode = this.$route.params.meetingCode;
    if (meetingCode) {
      this.getMeetingDetail(meetingCode);
    } else {
      this.$router.push({ name: "adminLogin" });
    }
    localStorage.setItem("meetingCode", meetingCode);
  },
  methods: {
    getMeetingDetail(meetingCode) {
      const data = {
        meetingCode: meetingCode,
      };
      this.$api.getMeetingDetail(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            if (res.data.meetingSubject) {
              this.meetingSubject = res.data.meetingSubject;
            }
            if (res.data.meetingSubjectEn) {
              this.meetingSubjectEn = res.data.meetingSubjectEn;
            }
          }
        }
      });
    },
    againFunc() {},
    registerMail() {
      this.$refs.formMail.validate((valid) => {
        if (valid) {
          let form = {
            roleCode: "#ROLE1#ROLE2#ROLE4",
            email: this.formMail.mail,
            password: this.formMail.password,
            msgCode: this.formMail.passcode,
          };
          this.$api.emailRegister(form).then((res) => {
            if (res.code === "200") {
              this.showType = "3";
            } else {
              let msg = "注册异常，请联系管理员！";
              if (res.retMsg) {
                msg =
                  this.$store.state.dict.lang == "en" && res.retMsgEn
                    ? res.retMsgEn
                    : res.retMsg;
              }
              this.$message({
                message: msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    registerMobile() {
      this.$refs.formMobile.validate((valid) => {
        if (valid) {
          let form = {
            roleCode: "#ROLE1#ROLE2#ROLE4",
            msgCode: this.formPhone.passcode,
            phoneNumber: this.formPhone.mobile,
            password: this.formPhone.password,
          };
          this.$api.phoneRegister(form).then((res) => {
            if (res.code === "200") {
              this.showType = "3";
              //var token = res.datas.map.token;
            } else {
              let msg = "注册异常，请联系管理员！";
              if (res.retMsg) {
                msg =
                  this.$store.state.dict.lang == "en" && res.retMsgEn
                    ? res.retMsgEn
                    : res.retMsg;
              }
              this.$message({
                message: msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    changeFunc(val) {
      // login register
      if (val == "login") {
        this.$router.push("/login/" + this.$route.params.meetingCode);
      }
    },
    choseWayFunc(val) {
      //mail phone
      this.activeWay = val;
    },
    //验证码相关
    sendMessageMail() {
      const reg =
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!reg.test(this.formMail.mail)) {
        this.$message({
          message: "请输入正确的邮箱",
          type: "error",
        });
        return;
      }
      this.formMail.sendCode = false;
      this.formMail.sendTime = 60;
      var auth_timetimer = setInterval(() => {
        this.formMail.sendTime--;
        if (this.formMail.sendTime <= 0) {
          this.formMail.sendCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
      this.$api
        .sendEmailVerificationCode({ email: this.formMail.mail,meetingCode:this.$route.params.meetingCode }, "post")
        .then((res) => {
          if (res.code === "200") {
            this.$message({
              message: this.$t("msg.emailCodeSuccess"),
              type: "success",
            });
          } else {
            this.$message({
              message: "邮箱验证码发送失败",
              type: "error",
            });
          }
        });
    },
    sendMessageMobile() {
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.formPhone.mobile)) {
        this.$message({
          message: this.$t("common.pleaseInputRightPhone"),
          type: "error",
        });
        return;
      }
      this.formPhone.sendCode = false;
      this.formPhone.sendTime = 60;
      var timetimer = setInterval(() => {
        this.formPhone.sendTime--;
        if (this.formPhone.sendTime <= 0) {
          this.formPhone.sendCode = true;
          clearInterval(timetimer);
        }
      }, 1000);

      this.$api
        .sendPhoneVerificationCode(
          { phoneNumber: this.formPhone.mobile,
            meetingCode:this.$route.params.meetingCode
          },
          "post"
        )
        .then((res) => {
          if (res.code === "200") {
            this.$message({
              message: this.$t("msg.smsSuccess"),
              type: "success",
            });
          } else {
            this.$message({
              message: "短信验证码发送失败",
              type: "error",
            });
          }
        });
    },
    queryVerifyCodeOfEmail(rule, value, callback) {
      this.$api
        .queryVerifyCodeOfEmail(
          { email: this.formMail.mail, verifyCode: this.formMail.passcode },
          "get"
        )
        .then((res) => {
          if (res.data) {
            callback();
          } else {
            callback(new Error("请输入正确的验证码！"));
          }
        });
      callback();
    },
  },
};
</script>

<style scoped lang="scss">
//  pc
@media screen and (min-width: 900px) {
  .loginpage {
    .el-form-item {
      margin-bottom: 20px;
    }
    .flex_center_between {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .loginHeader {
      width: 76%;
      margin: auto;
      padding-top: 6%;
      .leftBoxEn {
        height: 22px;
      }
      .leftBoxZh {
        height: 27px;
      }
      .rightBox {
        padding-right: 4%;
        ::v-deep.langBox {
          span {
            background: #3774fe;
            border-radius: 2px;
            color: #fff;
            border: 1px solid #3774fe;
            margin-left: 12px;
            padding: 6px 11px;
            cursor: pointer;
          }
        }
      }
    }
    .chose-way-out {
      span {
        padding-bottom: 4px;
      }
    }
    .out-box-login {
      .title-span {
        margin: 20px 0 40px 0;
      }
      .chose-way-out {
        margin-top: 42px;
      }
    }
    .device-type-cla {
      top: 18%;
    }
  }
  .endbox {
    height: 100vh;
    background: #bfd6fc;
  }
  .device-type-cla {
    width: 380px;
    position: absolute;
    right: 15%;
    top: 12%;
  }
  .loginpage {
    width: 100%;
    height: 100%;
    background: url(../../assets/login/bg.png) no-repeat center;
    background-size: 100% 100%;
  }
  .login-login {
    background: url(../../assets/images/logo-blue.png) no-repeat center;
    height: 18px;
    width: 200px;
    background-size: 100% 100%;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1500px) {
  .loginHeader {
    padding-top: 8% !important;
  }
}
//android
@media screen and (max-width: 900px) {
  .h5Box {
    .flex_center {
      display: flex;
      align-items: center;
    }
    .leftBoxEn {
      top: 45%;
      width: 170px;
      position: absolute;
      right: 22px;
    }
    .leftBoxZh {
      top: 45%;
      height: 18px;
      position: absolute;
      right: 0;
    }
    .handleBox {
      justify-content: flex-end;
      padding-right: 12px;
      margin-top: -20px;
      position: relative;
      z-index: 2;
      margin-bottom: 20px;
    }
    ::v-deep.langBox {
      span {
        background: #3774fe;
        border-radius: 2px;
        color: #fff;
        border: 1px solid #3774fe;
        margin-left: 12px;
        padding: 3px 6px;
        cursor: pointer;
      }
    }
  }
  .endbox {
    height: 100vh;
    background: #eef4fe;
  }
  .loginpage {
    width: 100%;
    height: 100vh;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 20px;
    background: #eef4fe;
  }
  .login-login {
    background: url(../../assets/images/logo-blue.png) no-repeat center;
    height: 18px;
    width: 200px;
    background-size: 100% 100%;
    margin: 20px auto 0;
  }
  .h5bg {
    position: relative;
    .titlogin {
      background: url(../../assets/images/logo-blue.png) no-repeat center;
      height: 18px;
      width: 200px;
      background-size: 100% 100%;
      position: absolute;
      top: 45%;
    }
  }
}

.out-box-login {
  .title-span {
    width: 100%;
    margin: 20px 0 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: #2a2a2a;
    line-height: 25px;
    text-align: center;
  }
  .chose-out {
    //margin-top: 10%;
    border-radius: 2px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .chose-in {
      border: 1px solid #3774fe;
      font-size: 18px;
      color: #3774fe;
      display: inline-block;
      width: 36%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .chose-in.active {
      background: #3774fe;
      color: #fff;
    }
  }

  .chose-way-out {
    justify-content: left;
    align-items: center;
    display: flex;
    margin: 16px 0;

    span {
      font-size: 16px;
      display: inline-block;
      cursor: pointer;
      border-bottom: 2px solid rgba(0, 0, 0, 0);
    }

    span.active {
      color: #3774fe;
      border-bottom: 2px solid #3774fe;
    }

    .shu {
      background: #999;
      width: 1px;
      height: 10px;
      margin: 0 10px;
    }
  }

  .me-button {
    border-radius: 2px;
    background: #3774fe;
    color: #fff;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
  }

  .little-btn-div {
    margin-top: 5px;

    .blue14 {
      cursor: pointer;
      color: #3774fe;
      font-size: 14px;
      float: right;
    }
  }

  .little-btn-divv2 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;

    span {
      color: #ff625a;
      border: 1px solid #ff625a;
      margin-left: 5px;
      padding: 0 5px;
      cursor: pointer;
    }
  }

  .sucess-out {
    .sucess-img-out {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .sucess-img {
        margin-top: 50px;
        width: 100px;
        height: 100px;
        background-size: 100% 100%;
        background: url(../../assets/login/icon-sucess-mini.png) no-repeat
          center;
      }

      span {
        margin: 0 0 0 10px;
      }
    }
  }

  .mail-tip-out {
    span {
      display: block;
      margin-top: 5px;
    }

    .mail-img-out {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .sucess-img {
        margin-top: 50px;
        width: 100px;
        height: 100px;
        background-size: 100% 100%;
        background: url(../../assets/login/icon-mail-mini.png) no-repeat center;
      }
    }

    .mail-btn-out {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        width: 180px;
        height: 48px;
        box-shadow: 0px 3px 12px 0px rgba(55, 116, 254, 0.46);
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
      }

      .bakck {
        border: 1px solid #3774fe;
        color: #3774fe;
      }

      .over {
        background: #3774fe;
        color: #ffffff;
      }
    }
  }
}
</style>
<style>
.out-box-login .el-input__inner {
  height: 48px !important;
  line-height: 48px;
}
</style>
